import {
    Component,
    h,
    Prop,
} from '@stencil/core';

@Component({
    tag: 'portal-loader',
    styleUrl: 'portal-loader.scss',
})
export class PortalLoader {
    /**
   * Size of the icon
   * @memberof PortalLoader
   */
    @Prop() size = '72px';

    render() {
        return (
            <svg width={this.size} height={this.size} viewBox="0 0 400 400" xmlns="https://www.w3.org/2000/svg">
                <path class="animated-path" d="M32,48H352V368" fill="none"></path>
                <path class="animated-path" d="M368,352H48V32" fill="none"></path>
            </svg>
        );
    }
}
